import React from 'react';

type NoticeIconProps = {
  color?: string;
  width?: number;
};

const NoticeIcon: React.FC<NoticeIconProps> = ({
  color = 'currentColor',
  width = 24,
}) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Circle outline */}
    <circle
      cx="12"
      cy="12"
      r="10"
      fill="none"
      stroke={color}
      strokeWidth="2"
    />
    {/* Exclamation mark: vertical line */}
    <line
      x1="12"
      y1="7"
      x2="12"
      y2="13"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    {/* Exclamation mark: dot */}
    <circle cx="12" cy="17" r="1" fill={color} />
  </svg>
);

export default NoticeIcon;
